"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
function CheckIcon(props) {
    return (0, jsx_runtime_1.jsx)("svg", { "aria-label": "checkmark", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: "img", fill: "currentColor", className: "ps-icon-svg", ...props, children: (0, jsx_runtime_1.jsx)("path", { d: "m9.59 14.58-2.818-2.818a.5.5 0 0 0-.706 0l-.71.704a.5.5 0 0 0-.003.708h.002l3.881 3.882a.5.5 0 0 0 .707 0l9.293-9.292a.5.5 0 0 0 0-.708l-.703-.702a.5.5 0 0 0-.707 0L9.59 14.58Z" }) });
}
exports.default = CheckIcon;
